import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class BeforeUnloadBypassService {
  private bypass = false;
  enable() { this.bypass = true; }
  disable() { this.bypass = false; }
  get isEnabled() { return this.bypass; }
}
